var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_support_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8 24.0005L12.5 20.4005H12.2C9.36 20.4005 6.95 19.4105 4.97 17.4305C2.99 15.4505 2 13.0405 2 10.2005C2 7.36049 2.99 4.95049 4.97 2.97049C6.95 0.990488 9.36 0.000488281 12.2 0.000488281C13.62 0.000488281 14.945 0.265488 16.175 0.795488C17.405 1.32549 18.485 2.05549 19.415 2.98549C20.345 3.91549 21.075 4.99549 21.605 6.22549C22.135 7.45549 22.4 8.78049 22.4 10.2005C22.4 11.7005 22.155 13.1405 21.665 14.5205C21.175 15.9005 20.505 17.1805 19.655 18.3605C18.805 19.5405 17.795 20.6105 16.625 21.5705C15.455 22.5305 14.18 23.3405 12.8 24.0005ZM15.2 19.6205C16.62 18.4205 17.775 17.0155 18.665 15.4055C19.555 13.7955 20 12.0605 20 10.2005C20 8.02049 19.245 6.17549 17.735 4.66549C16.225 3.15549 14.38 2.40049 12.2 2.40049C10.02 2.40049 8.175 3.15549 6.665 4.66549C5.155 6.17549 4.4 8.02049 4.4 10.2005C4.4 12.3805 5.155 14.2255 6.665 15.7355C8.175 17.2455 10.02 18.0005 12.2 18.0005H15.2V19.6205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 139",
    x: 11,
    y: 8.10046,
    width: 2.7,
    height: 7.6,
    rx: 1.35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 12.35,
    cy: 5.95095,
    r: 1.35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.d14cc03b67b5f1def99963683868fdfd.svg";
export { ForwardRef as ReactComponent };